import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { MiGelFileRequestDto, MiGelFileResultDto, MiGelImportRequest, MiGelImportResponse } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/migel-import`;

export const previewMiGelDataFromFile = (values: Partial<MiGelFileRequestDto>, source: CancelTokenSource)
    : Promise<Array<MiGelFileResultDto>> => {

  let bodyFormData = new FormData();
  Object.keys(values).forEach((key) => {
    let value = values[key as keyof MiGelFileRequestDto];

    if (value) {
      if (typeof value === "number") {
        //@ts-ignore
        value = value.toString();
      }
      //@ts-ignore
      bodyFormData.append(key, value);
    }

  });

  return axios
      .post(`${apiUri}/preview`, bodyFormData, {cancelToken: source.token})
      .then(response => response.data);
};


export const miGelImport = (request: Partial<MiGelImportRequest>,
                                    source: CancelTokenSource): Promise<MiGelImportResponse> => {
  return axios
      .post(`${apiUri}/import`, request, {cancelToken: source.token})
      .then(response => response.data)
};
